
export default {
  props: {
    customHeight: {
      type: Boolean,
      default: false
    }
  }
}
